export default __webpack_public_path__ + "static/media/Surface.6edd9da3.png";